import { render } from "./FormStepTab.vue?vue&type=template&id=4d50a2fe"
import script from "./FormStepTab.vue?vue&type=script&lang=js"
export * from "./FormStepTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/FormStepTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d50a2fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d50a2fe', __exports__)) {
    api.reload('4d50a2fe', __exports__)
  }
  
  module.hot.accept("./FormStepTab.vue?vue&type=template&id=4d50a2fe", () => {
    api.rerender('4d50a2fe', render)
  })

}


export default __exports__